import { Component, Input, OnInit } from "@angular/core";
import { forkJoin, of } from "rxjs";
import { catchError } from "rxjs/operators";
import {
  InvoiceSubscriptionsV2Service,
  PublicSubscriptionPlanItem,
  PublicDocExtensionPlanItem,
  PublicCompanyExtensionPlanItem,
  PublicTokenExtensionPlanItem,
  PublicPlansListResponse,
} from "src/app/services/invoice-subscriptions-v2.service";

@Component({
  selector: "app-plans",
  templateUrl: "./plans.component.html",
  styleUrls: ["./plans.component.scss"],
})
export class PlansComponent implements OnInit {
  /** عند true يُخفى الـ hero (مثلاً صفحة /pricing التي لها عنوان صفحة أعلى) */
  @Input() embedMode = false;

  curentLang = "ar";
  loading = true;
  loadError = false;

  subscriptionPlans: PublicSubscriptionPlanItem[] = [];
  docExtensionPlans: PublicDocExtensionPlanItem[] = [];
  companyExtensionPlans: PublicCompanyExtensionPlanItem[] = [];
  tokenExtensionPlans: PublicTokenExtensionPlanItem[] = [];

  constructor(private invoiceV2: InvoiceSubscriptionsV2Service) {}

  ngOnInit() {
    this.curentLang = localStorage.getItem("curentLang") || "ar";
    this.loadAll();
  }

  private emptyRes<T>(): PublicPlansListResponse<T> {
    return { status: 200, count: 0, plans: [] };
  }

  loadAll(): void {
    this.loading = true;
    this.loadError = false;
    forkJoin({
      main: this.invoiceV2
        .getPublicSubscriptionPlans()
        .pipe(catchError(() => of(this.emptyRes<PublicSubscriptionPlanItem>()))),
      docs: this.invoiceV2
        .getPublicDocExtensionPlans()
        .pipe(catchError(() => of(this.emptyRes<PublicDocExtensionPlanItem>()))),
      companies: this.invoiceV2
        .getPublicCompanyExtensionPlans()
        .pipe(catchError(() => of(this.emptyRes<PublicCompanyExtensionPlanItem>()))),
      tokens: this.invoiceV2
        .getPublicTokenExtensionPlans()
        .pipe(catchError(() => of(this.emptyRes<PublicTokenExtensionPlanItem>()))),
    }).subscribe({
      next: (res) => {
        this.subscriptionPlans = res.main.plans ?? [];
        this.docExtensionPlans = res.docs.plans ?? [];
        this.companyExtensionPlans = res.companies.plans ?? [];
        this.tokenExtensionPlans = res.tokens.plans ?? [];
        this.loading = false;
      },
      error: () => {
        this.loadError = true;
        this.loading = false;
      },
    });
  }

  planName(p: { name_en: string; name_ar: string; name_he: string }): string {
    if (this.curentLang === "ar") return p.name_ar || p.name_en || p.name_he || "";
    if (this.curentLang === "he") return p.name_he || p.name_en || p.name_ar || "";
    return p.name_en || p.name_ar || p.name_he || "";
  }

  planDesc(p: {
    description_en?: string;
    description_ar?: string;
    description_he?: string;
  }): string {
    if (this.curentLang === "ar") return p.description_ar || p.description_en || "";
    if (this.curentLang === "he") return p.description_he || p.description_en || "";
    return p.description_en || p.description_ar || "";
  }
}
